var Margins = /*#__PURE__*/ function(Margins) {
    Margins["Large"] = "large";
    Margins["Medium"] = "medium";
    Margins["None"] = "none";
    Margins["Small"] = "small";
    return Margins;
}({});

export { Margins };
//# sourceMappingURL=margin.js.map
